import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  spinner: {
    stroke: theme.palette.primary.light,
  },
}));

export default useStyles;
